/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jf_beautify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beautify`)
};

const es_jf_beautify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embellecer`)
};

const de_jf_beautify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatieren`)
};

const nl_jf_beautify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mooi maken`)
};

const fr_jf_beautify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embellir`)
};

const it_jf_beautify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatta`)
};

const pt_br2_jf_beautify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embelezar`)
};

const pt_jf_beautify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embelezar`)
};

const ja_jf_beautify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beautify`)
};

const zh_jf_beautify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`美化`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jf_beautify = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jf_beautify(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jf_beautify", locale)
	if (locale === "en") return en_jf_beautify(inputs)
	if (locale === "es") return es_jf_beautify(inputs)
	if (locale === "de") return de_jf_beautify(inputs)
	if (locale === "nl") return nl_jf_beautify(inputs)
	if (locale === "fr") return fr_jf_beautify(inputs)
	if (locale === "it") return it_jf_beautify(inputs)
	if (locale === "pt-BR") return pt_br2_jf_beautify(inputs)
	if (locale === "pt") return pt_jf_beautify(inputs)
	if (locale === "ja") return ja_jf_beautify(inputs)
	return zh_jf_beautify(inputs)
};